import {initScrollableHeader} from '../Utility/ScrollableHeaderUtility';

export function initAllTabs(element: ParentNode = document) {
  element.querySelectorAll('.js-tabs').forEach((tabWrapper) => {
    if (tabWrapper instanceof HTMLElement) {
      initTabsWrapper(tabWrapper);
    }
  });
}

export function initTabsWrapper(tabWrapper: HTMLElement) {
  const tabButtons = tabWrapper.querySelectorAll('.js-tabsButton');
  tabButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      if (button instanceof HTMLElement) {
        const id = button.dataset.target;
        if (id) {
          showTab(id, tabWrapper);
          button.parentElement?.classList.add('tab__headerListItem--active');
        }
      }
    });
  });

  if (tabWrapper.classList.contains('js-scrollableHeader') || window.matchMedia('(max-width: 1024px)').matches) {
    tabWrapper.classList.remove('tab--left');
    tabWrapper.classList.add('tab--top');
    tabWrapper.classList.add('scrollableHeader');
    initScrollableHeader(tabWrapper);
  }

  initTabChanger(tabWrapper);
}

function showTab(id: string, tabWrapper: HTMLElement) {
  const target = tabWrapper.querySelector('#tab-' + id);
  const activeTab = tabWrapper.querySelector('.tabContent__item--active');
  activeTab?.classList.remove('tabContent__item--active');
  const activeTabHeader = tabWrapper.querySelector('.tab__headerListItem--active');
  activeTabHeader?.classList.remove('tab__headerListItem--active');
  target?.classList.add('tabContent__item--active');
}

function initTabChanger(tabWrapper: HTMLElement) {
  const changeButtons = tabWrapper.querySelectorAll('.js-changeTab');
  changeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      if (button instanceof HTMLElement) {
        const id = button.dataset.target;
        if (!id) {
          return;
        }
        const buttonToClick: HTMLButtonElement | null = tabWrapper.querySelector('.js-tabsButton[data-target="' + id + '"]');
        if (!buttonToClick) {
          return;
        }
        buttonToClick.click();
      }
    });
  });
}
